var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#9B1010",
  d: "M42 14L40 40 14 42z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#B71C1C",
  d: "M28 28L40 40 42 14z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C62828",
  d: "M24 12.336A22.621 11.664 0 1 0 24 35.664A22.621 11.664 0 1 0 24 12.336Z",
  transform: "rotate(-45.001 24 24)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#E53935",
  d: "M10 17L17 10 25 6 31 10 28 19 19 27 10 30 6 24z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF5252",
  d: "M31,10l-6-4h11L31,10z M42,15l-11-5l-3,9L42,15z M19,27l13.235,5.235L28,19L19,27z M10,30l4,12l5-15L10,30z M6,24v11l4-5L6,24z"
});
function SvgIcons8RubyProgrammingLanguage240(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8RubyProgrammingLanguage240);
export default __webpack_public_path__ + "static/media/icons8-ruby-programming-language-240.c3aba87a9cd5fa18e92be3a5882be29a.svg";
export { ForwardRef as ReactComponent };